module.exports = __webpack_public_path__ + "static/preview-maya-627d1d709e120baa981ea5b4f9548846.wav";